import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d83e5796"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin":"10px"} }


import store from '../store'
import { ref, defineComponent, onMounted } from 'vue'
import { apiPostData, showRequestResult, getI18n } from '../utils'
import {
  Edit,
  Check
} from '@element-plus/icons-vue'

// 解决vs中的语法错误提示
const __default__ = defineComponent({
  name: 'EditUserProfilePage'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const refIsEditUserName = ref(false)
const refUserName = ref('')

onMounted(async () => {
  refUserName.value = store.state.userName
})
const startEdit = () => {
  refIsEditUserName.value = true
}
const save = () => {
  refIsEditUserName.value = false
  store.state.userName = refUserName.value
  const postData = { userName: refUserName.value }
  console.log('postData=', postData)
  apiPostData('/action?__action_id=__update_user_name', postData)
    .then(data => {
      showRequestResult(data, '保存成功', '保存失败', '', false, true, false)
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      "label-width": "auto",
      style: {"max-width":"600px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(getI18n)('账户')+':'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, { class: "mx-1" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(store).state.userAccount), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(getI18n)('用户名')+':'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, {
              class: "full-width",
              gutter: 0,
              justify: "start",
              style: {"margin":"0px !important"}
            }, {
              default: _withCtx(() => [
                (refIsEditUserName.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_col, { span: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: refUserName.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refUserName).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 4 }, {
                        default: _withCtx(() => [
                          (refIsEditUserName.value)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                icon: _unref(Check),
                                circle: "",
                                onClick: save
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_el_col, {
                        span: 20,
                        class: "left-align"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_text, { class: "mx-1" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(refUserName.value), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 4 }, {
                        default: _withCtx(() => [
                          (!refIsEditUserName.value)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                icon: _unref(Edit),
                                circle: "",
                                onClick: startEdit
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ], 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    })
  ]))
}
}

})